import { SVGFC } from '@repo/toolkit/types'

const ArrowUpIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4421 7.19858C12.3884 7.13628 12.3209 7.08614 12.2443 7.05179C12.1678 7.01744 12.0842 6.99976 11.9996 7.00001C11.926 6.99956 11.853 7.01325 11.7851 7.04024C11.7172 7.06724 11.6557 7.10701 11.6043 7.15715L9.35201 9.30572C9.24667 9.40617 9.1875 9.54233 9.1875 9.68429C9.1875 9.82626 9.24667 9.96241 9.35201 10.0629C9.45748 10.1632 9.60045 10.2195 9.74952 10.2195C9.89858 10.2195 10.0416 10.1632 10.147 10.0629L11.4371 8.82644V16.4643C11.4371 16.6064 11.4963 16.7426 11.6018 16.8431C11.7073 16.9435 11.8504 17 11.9996 17C12.1487 17 12.2918 16.9435 12.3973 16.8431C12.5028 16.7426 12.5621 16.6064 12.5621 16.4643V8.83286L13.8536 10.06C13.959 10.1601 14.1018 10.2163 14.2507 10.2163C14.3996 10.2163 14.5424 10.1601 14.6479 10.06C14.7532 9.95956 14.8124 9.8234 14.8124 9.68143C14.8124 9.53947 14.7532 9.40331 14.6479 9.30286L12.4421 7.19858Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowUpIcon
